module.exports = __webpack_public_path__ + "img/gameday_select.28cfa725.png";